<ng-container *ngFor="let alert of listAlert; let i = index">
    <ngb-toast [id]="i + '_alert'" *ngIf="alert.view" [ngStyle]="{'top': getTopPosition(i) + 'px'}" [autohide]="alert.autoHidde" [delay]="alert.delay" (hidden)="alert.view = !alert.view; removeAlert(i)"
    [ngClass]="alert.valClass" style="position: absolute;">
    <div style="display: flex; flex-direction: row;align-items: flex-start;">
        <container-element [ngSwitch]="alert.valClass">
            <img *ngSwitchCase="'success'" src="assets/icone_varie/ok.svg" style="width: 20px; margin-right: 5px;">
            <img *ngSwitchCase="'warning'" src="assets/icone_varie/danger.svg" style="width: 20px; margin-right: 5px;">
            <img *ngSwitchCase="'error'" src="assets/icone_varie/error.svg" style="width: 20px; margin-right: 5px;">
        </container-element>
        <h5 style="flex: 1;margin: 0;margin-top: 3px;">{{alert.title}}</h5>
        <img *ngIf="!alert.autoHidde" src="assets/icone_varie/closeAlert.png" style="cursor: pointer;transform: rotate(45deg);" width="20px" (click)="alert.view = !alert.view; removeAlert(i);">
    </div>

    
</ngb-toast>
</ng-container>
